export async function getRecordBadge(held, recordClass)
{
	return {
		bg: (await import(`../../img/map/${held ? 'gold' : 'grey'}.png`)).default,
		icon: (await import(`../../img/map/${recordClass.toLowerCase()}.png`)).default
	}
}
